import { render, staticRenderFns } from "./RegistrationStep.vue?vue&type=template&id=30b6c23b&scoped=true&"
import script from "./RegistrationStep.vue?vue&type=script&lang=ts&"
export * from "./RegistrationStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b6c23b",
  null
  
)

export default component.exports